import { useFormContext } from "react-hook-form";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { VRSTA_OPERATERA } from "../../../../enums";
import { useEffect } from "react";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const nazivPolja =
  "operaterPlatforme.primarniIdentifikator.drzavaRezidentnosti.oznaka";
const nazivPoljaEu =
  "operaterPlatforme.primarniIdentifikator.drzavaRezidentnosti.euSifra";
const Index = () => {
  const { register, getValues, setValue, watch } = useFormContext();
  const drzavaRezidentnosti = getValues(nazivPolja);
  const sifraEu = watch(nazivPoljaEu);
  const vrstaOperatera = getValues("operaterPlatforme.vrstaOperatera.id");
  const drzave = getValues("drzave");

  useEffect(() => {
    if (parseInt(vrstaOperatera) === VRSTA_OPERATERA.IZVAN_EU) {
      setValue(nazivPolja, "");
      setValue(nazivPoljaEu, "");
    } else {
      setValue(nazivPolja, "HRV");
      setValue(nazivPoljaEu, "HR");
    }
  }, [vrstaOperatera]);

  return (
    <>
      <FormControl fullWidth error={!daLiJePoljeValidno(nazivPoljaEu)}>
        <InputLabel id={nazivPolja}>
          *Država rezidentnosti (Country of residency)
        </InputLabel>
        <Select
          disabled={parseInt(vrstaOperatera) === VRSTA_OPERATERA.IZ_RH}
          labelId={nazivPolja}
          id={nazivPolja}
          value={
            drzavaRezidentnosti && drzave && drzave.length > 0
              ? drzavaRezidentnosti
              : ""
          }
          label="*Država rezidentnosti (Country of residency)"
          variant={"standard"}
          {...register(nazivPolja)}
          onChange={(e: SelectChangeEvent<any>) => {
            setValue(nazivPolja, e.target.value);
            setValue(
              nazivPoljaEu,
              drzave.find((drzava: any) => drzava.oznaka === e.target.value)
                .euSifra
            );
          }}
        >
          {drzave.map((drzava: any, key: number) => (
            <MenuItem
              key={key}
              value={drzava.oznaka}
              disabled={
                drzava.oznaka === "HRV" &&
                parseInt(vrstaOperatera) === VRSTA_OPERATERA.IZVAN_EU
                  ? true
                  : false
              }
            >
              {drzava.naziv}
            </MenuItem>
          ))}
        </Select>
        <PorukaGreskePolja nazivPolja={`${nazivPoljaEu}`} />
      </FormControl>
      {drzave && drzave.length > 0 && drzavaRezidentnosti && (
        <input type={"hidden"} value={sifraEu} {...register(nazivPoljaEu)} />
      )}
    </>
  );
};

export default Index;
